import React, { Component } from "react";
import { Input, Table, Pagination, Rate } from "antd";
// import { SearchOutlined } from "@ant-design/icons";
import EmployeeTotalJobCard from "./EmployeeTotalJobCard";
import EmployeeStatus from './EmployeeStatus'
import Api from "../../../ServiceApi";
import Cookies from "js-cookie";
let dataSource = [
    // {
    //     job_no: 41000096645,
    //     ma_type: 'CM',
    //     job_category_name: 'Claim', 
    //     area_code: 'BKK01',
    //     location_name: 'Center Point',
    //     assign_date: '07/01/2020',
    //     status: 'Finished'
    // },
    // {
    //     job_no: 41000010445,
    //     ma_type: 'PM',
    //     job_category_name: 'Claim', 
    //     area_code: 'BKK01',
    //     location_name: 'Center Point',
    //     assign_date: '26/02/2020',
    //     status: 'Transfer'
    // },
    // {
    //     job_no: 41000001294,
    //     ma_type: 'IM',
    //     job_category_name: 'Claim', 
    //     area_code: 'BKK01',
    //     location_name: 'ลานน้ำพุ สยามพารากอน',
    //     assign_date: '11/04/2020',
    //     status: 'TL Approve'
    // },
]
const columns = [
      {
    title: "Job No",
    dataIndex: "job_no",
    key: "job_no",
    render: (item) => <button className="c-blue" style={{"text-decoration":"underline"}}>{item}</button>,
    sorter: (a, b) => a.job_no - b.job_no
  },
  {
    title: "Ma Type",
    dataIndex: "ma_type",
    key: "ma_type",
    sorter: (a, b) => a.ma_type.localeCompare(b.ma_type)
  },
  {
    title: "Job Category",
    dataIndex: "job_category_name",
    key: "job_category_name",
    sorter: (a, b) => a.job_category_name.localeCompare(b.job_category_name)
  },
  {
    title: "Area Code",
    dataIndex: "area_code",
    key: "area_code",
    sorter: (a, b) => a.area_code.localeCompare(b.area_code)
  },
    {
    title: "Location Name",
    dataIndex: "location_name",
    key: "location_name",
    sorter: (a, b) => a.location_name.localeCompare(b.location_name)
  },
  {
    title: "Assign Date",
    dataIndex: "assign_date",
    key: "assign_date",
    sorter: (a, b) => a.assign_date.localeCompare(b.assign_date)
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (item) => <span className="c-blue">{item}</span>,
    sorter: (a, b) => a.status.localeCompare(b.status.length)
  },
];

class AllEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      last_job: [],
      filter: "",
      employee: [],
      data: [],
      active: 1,
      emplist_count: 0,
      emplist_page: 1,
      selected_emp: {},
      emp_details: {},
      page: 1,
      deee: null,
      emp_spinner: 1,
      isEmpDetailReturned: false,
      ratingValue: 3,
    };
  }

  async componentDidMount() {
    //this.setState({data: this.state.employee});
    const employee_list_api = await Api.post(
      "get_team_management_employee_list",
      {
        //company_id:1,
        company_id: Cookies.get("companyid"),
        operator_id:Cookies.get("operator_id"),
        project_id:Cookies.get("project_id"),
        is_active: 1,
      }
    );

    if (employee_list_api.data.result.code === "P") {
      this.setState({
        employee: employee_list_api.data.data.employee_list,
        data: employee_list_api.data.data.employee_list,
        selected_emp: employee_list_api.data.data.employee_list[0],
      }, () => console.log('employee list',this.state.employee));
      this.props.headerHandler(
        employee_list_api.data.data.employee_list.length,
        1
      );
      const employee_detail_api = await Api.post(
        "get_team_management_employee_detail",
        {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          pk_id: !this.state.employee[0] ? "" : this.state.employee[0].emp_id,
        }
      );
      if (employee_detail_api.data.result.code === "P") {
        if(employee_detail_api.data.data.employee_last_jobs.length === 0){
          dataSource = []
        }
        this.setState({
          emp_details: employee_detail_api,
          active: employee_detail_api.data.data.employee_detail[0].emp_id,
          emp_spinner: 0,
          isEmpDetailReturned: true,
        },() => console.log('emp details', this.state.emp_details.data.data));
      }
    }
  }
  // handleRateChange = value => {
  //   console.log('rating value', value)
  //   this.setState({ratingValue : value})
  // }
  empOnclick = (employee, emp_id) => {
    this.setState({
      active: emp_id,
      emp_spinner: 1,
    });
    // console.log("when emp is clicked", employee, "id", emp_id);
    this.getEmpdetail(employee);
  };
  getEmpdetail(employee) {
    const employee_detail_api = Api.post(
      "get_team_management_employee_detail",
      {
        TokenUser: Cookies.get("OpereationToken"),
        company_id: employee.company_id,
        operator_id: employee.operator_id,
        project_id: employee.project_id,
        pk_id: employee.emp_id,
      }
    );
    employee_detail_api
      .then((val) => {
        console.log("employee detail", val);
        this.setState({
          emp_spinner: 0,
          selected_emp: val.data.data.employee_detail[0],
          emp_details: val,
        });
      })
      .catch((err) => {
        this.setState({
          emp_spinner: 0,
        });
        console.error(err);
      });
  }
  handleChange = (e) => {
    let currentList = [];
    let newList = [];
    this.setState({ filter: e.target.value });
    if (e.target.value !== "") {
      currentList = this.state.employee;
      newList = currentList.filter((item) => {
        return item.emp_name
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
    } else {
      newList = this.state.employee;
    }
    this.setState({
      data: newList,
      page: 1,
    });
  };
  paginationGen() {
    return (
      <Pagination
        className="text-right"
        onChange={(page) => this.setState({ page: page })}
        showSizeChanger={false}
        size="small"
        current={this.state.page}
        defaultPageSize={8}
        total={this.state.data.length}
        showTotal={() => {
          return "Total " + this.state.data.length;
        }}
      />
    );
  }
  render() {
    const {
      filter,
      last_job,
      data,
      active,
      emplist_count,
      emp_details,
      emplist_page,
      isEmpDetailReturned,
      ratingValue
    } = this.state;
    console.log("emp_details from render", emp_details, isEmpDetailReturned);
    function isNull(a, type) {
      //type null:text,1:number
      return !a ? (!type ? "-" : "0") : a;
    }
    function arrObjhandler(a, b) {
      let res = !a ? {} : a[0];
      return res[b];
    }
    return (
      <div style={{ padding: "20px" }}>
        <div className="row">
          <div className="col-3">
            <Input
              value={filter}
              className="mb-4"
              placeholder="Search employee name"
              suffix={<img src={Api.absoluteUrl("/icon/search.svg")} alt="" />}
              onChange={this.handleChange}
            />
            {/* the card tab for left side */}
            {data.map((item, index) => {
              {
                /* console.log('employee data', item) */
              }
              return index + 1 >= this.state.page * 8 - 7 &&
                index + 1 <= this.state.page * 8 ? (
                <div
                  key={item.emp_id}
                  className={
                    active === item.emp_id
                      ? "card-team-select active"
                      : "card-team-select"
                  }
                  onClick={() => this.empOnclick(item, item.emp_id)}
                >
                  <button className="w-100 d-flex align-items-center">
                    <div className="mr-3">
                      <img
                        src={Api.absoluteUrl("/img/pic_employee.png")}
                        width="40"
                      />
                    </div>
                    <div>
                      <span>
                        <h5 className="font-thai-b fs-18 m-0">
                          {isNull(item.emp_name)} (Store)
                        </h5>
                      </span>
                      <span className="font-thai-b fs-18">
                        {/* {isNull(item.employee_position_name)} */}
                        {/* 20 Jobs */}
                      </span>
                    </div>
                  </button>
                </div>
              ) : (
                ""
              );
            })}
            {this.paginationGen()}
          </div>
          {/* right side */}
          <div className="col-9">
            <div className="text-right">
              {/* <button className="btn btn-warning">
                <img
                  src={Api.absoluteUrl("/icon/rename_dropdown.svg")}
                  className="mr-2"
                />
                abcd
              </button> */}
              <Rate style={{color:"#000f9f"}} value={ratingValue} disabled />
            </div>

            <div className="row mb-4">
              <div className="col-2">
                <img
                  src={Api.absoluteUrl("/img/pic_employee.png")}
                  className="img-fluid"
                />
              </div>
              <div className="col-10">
                <h3 className="c-blue font-thai-b fs-34">
                  {isNull(this.state.selected_emp.emp_name)}
                </h3>
                <div className="row">
                  <div className="col-4">
                    <div className="font-thai-sb fs-18">
                      <img
                        src={Api.absoluteUrl("/icon/position.svg")}
                        alt=""
                        className="mr-2"
                      />
                      {/* {isNull(this.state.selected_emp.employee_position_name)} */}
                      Senior Engineer
                    </div>
                    <div className="font-thai-sb fs-18">
                      <img
                        src={Api.absoluteUrl("/icon/mail.svg")}
                        alt=""
                        className="mr-2"
                      />
                      {isNull(this.state.selected_emp.email)}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="font-thai-sb fs-18">
                      <img
                        src={Api.absoluteUrl("/icon/clock.svg")}
                        alt=""
                        className="mr-2"
                      />
                      {isNull(this.state.selected_emp.employee_shift_name)}
                      {/* 08.45 PM - 10.00 PM */}
                    </div>
                    <div className="font-thai-sb fs-18">
                      <img
                        src={Api.absoluteUrl("/icon/phone.svg")}
                        alt=""
                        className="mr-2"
                      />
                      {isNull(this.state.selected_emp.tel)}
                    </div>
                  </div>
                  <div className="col-5">
                    <div
                      className="font-thai-sb fs-18"
                      style={{ display: "flex" }}
                    >
                      <span>
                        <img
                          src={Api.absoluteUrl("/icon/people.svg")}
                          alt=""
                          className="mr-2"
                        />
                        {/* {(!this.state.selected_emp.is_lead ? "" : "Team Lead ") +
                        (!this.state.selected_emp.team_name
                          ? "-"
                          : this.state.selected_emp.team_name)} */}
                        Team:
                        <ul>
                          <li>
                            <span>
                              {/* <a href="#" className="c-blue" style={{"text-decoration":"underline"}}>Team01</a> Team Lead */}
                              -
                            </span>
                          </li>
                          <li>
                            <span>
                              {/* <a href="#" className="c-blue" style={{"text-decoration":"underline"}}>Team05</a> Employee */}
                              -
                            </span>
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-8">
                {isEmpDetailReturned ? <EmployeeTotalJobCard
                  empTotalJob={
                    emp_details.data.data.employee_total_jobs
                  }
                /> : ''}
              </div>
            {/* <EmployeeStatus statusData={} /> */}
            <EmployeeStatus />
            </div>

            <div className="mb-4">
              {/* skill */}
              <h3 className="font-mont-b fs-16 c-blue text-uppercase">
                <img
                  src={Api.absoluteUrl("/icon/skill.svg")}
                  className="mr-2"
                  width="26"
                  alt=""
                />
                Skill
              </h3>
              <ul className="tag-skill">
                {isEmpDetailReturned ?
                  this.state.emp_details.data.data.employee_skill.map((item, index) => {
                      console.log('item', item)
                      return <li key={index}>{item.ma_skill_name}</li>;
                    }): ""}
              </ul>
            </div>
            {/* last jobs */}
            <div>
              <h3 className="font-mont-b fs-16 c-blue text-uppercase">
                <img
                  src={Api.absoluteUrl("/icon/last_job.svg")}
                  className="mr-2"
                  width="26"
                  alt=""
                />
                Last Jobs
              </h3>

              {/* table for last jobs */}
              <Table
                columns={columns}
                // dataSource={isEmpDetailReturned ? this.state.emp_details.employee_last_jobs : []}
                dataSource={dataSource}
                pagination={false}
              />
            </div>
            {this.state.emp_spinner === 1 ? (
              <div>
                <div
                  className="position-absolute"
                  style={{
                    backgroundColor: "#505050",
                    opacity: 0.1,
                    height: "calc(100%)",
                    width: "100%",
                    top: 0,
                    left: 0,
                    zIndex: 1000,
                  }}
                ></div>
                <div
                  className="spinner-border position-absolute"
                  style={{
                    width: "15rem",
                    height: "15rem",
                    top: "calc(50% - 7.5rem)",
                    left: "calc(50% - 7.5rem)",
                    zIndex: 1001,
                  }}
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AllEmployee;
